import React from 'react'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'
import { Line } from 'react-chartjs-2'
import formatCurrency from "../../helpers/currencyHelper"

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
)

const exampleData = {
    labels: ['day1', 'day2'],
    datasets: [
        {
            label: 'Users',
            data: [1, 2],
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
            yAxisID: 'y',
        },
        {
            label: 'Tasks',
            data: [1, 2],
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
            yAxisID: 'y1',
        },
    ],
}

const LineChart = ({ title = false, data = exampleData, displayLegend = true }) => {
    const maxValue =  Math.max(
        ...data.datasets.flatMap((set) => set.data)
    )

    const options = {
        responsive: true,
         maintainAspectRatio: false,
        // Añadir padding para separar los valores de los bordes
        layout: {
            padding: {
                top: 40,   
                bottom: 20, 
                left: 20,
                right: 40
            }
        },
        interaction: {
            mode: 'index',
            intersect: false,
        },
        stacked: false,
        plugins: {
            legend: {
                display: displayLegend,
                position: 'bottom',
            },
            title: {
                display: title ? true : false,
                text: title,
            },
            tooltip: {
                mode: 'index', // Agrupar tooltips por etiquetas
                intersect: true,
                position: 'nearest', // average - nearest
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        label += formatCurrency(context.parsed.y);
                        return label;
                    }
                }
            },
            datalabels: {
                display: true,
                align: 'top',
                anchor: 'end',
                offset: 8,
                color: '#333',
                font: {
                    weight: 'bold',
                    size: 12
                },
                formatter: value => formatCurrency(value)
            }
        },    
        scales: {
            x: {                
                offset: true,
                grid: {
                    display: true,
                    drawBorder: true,
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                min: 0,
                max: maxValue * 1.1, // Asegurar que ambos ejes tengan el mismo valor máximo
                grid: {
                    display: true,
                    drawBorder: true,
                },
                ticks: {
                    padding: 10,
                    //stepSize: 1, // Espaciado de las divisiones
                    callback: function (value) {
                        return formatCurrency(value) // Asegurar que los valores no tengan decimales
                    },
                },
            }
        },
        elements: {
            line: {
                tension: 0.2, // Curva suave en las líneas
            },
            point: {
                radius: 4,           // Tamaño de los puntos
                hoverRadius: 6,      // Tamaño al hacer hover
                borderWidth: 2,      // Grosor del borde del punto
                hoverBorderWidth: 3  // Grosor del borde al hacer hover
            }
        }
    }

    return <div style={{ height: '400px', position: 'relative' }}>
            <Line data={data} options={options} />
        </div>
}

export default LineChart